<template>
  <div id="login" >
    <div v-if="!signedIn && !requiredNewPass">
      <div class="sectionHeader">
        {{ $t('login.lblHeader') }}
      </div>
      <div class="sectionheader">
        <p>
          {{ $t('login.lblMessage1') }}<br>
          {{ $t('login.lblMessage2') }}
          <router-link :to="{path:'identification', query: $route.query}">{{$t('login.lblRegister')}}</router-link>
          {{ $t('login.lblMessage3') }}
        </p>
      </div>
      <form id="loginform" @submit.prevent="login">
        <div class="form-group">
          <div class="form-label">
            <label for="inputUsername" style="font-weight: bold;">{{ $t('login.lblUserName') }}</label>
            {{ $t('login.lblUserNameDescription') }}
          </div>
          <input
            id="inputUsername"
            type="text"
            class="form-control"
            :placeholder="$t('login.placeholderUserName')"
            v-model="username"
            maxlength="11"
            required>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label for="inputpassword" style="font-weight: bold;">{{ $t('login.lblPassword') }}</label>
            {{ $t('login.lblPasswordDescription1') }}
            <router-link :to="{path:'forgotpass', query: $route.query}" >{{$t('login.lblPasswordDescription2')}}</router-link>
            {{ $t('login.lblPasswordDescription3') }}
          </div>
          <input
            id="inputpassword"
            type="password"
            class="form-control"
            :placeholder="$t('login.placeholderPassword')"
            v-model="password"
            required>
        </div>
        <div class="validMsg">
          <div
            v-if="this.errorMessage==='login.errorMessageLoginChallengeCount'">
            <span v-html="$t('login.errorMessageLoginChallengeCount1')" />
            <router-link :to="{ path:'forgotpass', query: $route.query}">
              {{ $t('login.errorMessageLoginChallengeCount2') }}
            </router-link>
            <span>{{ $t('login.errorMessageLoginChallengeCount3') }}</span>
          </div>
          <div v-else v-html="$t(this.errorMessage)" />
        </div>
        <div class="validMsg">
          {{ this.message }}
        </div>
        <div class="descriptions">
          <p>
          {{ $t('login.lblDescriptions1') }}<br>
          {{ $t('login.lblDescriptions2') }}<br>
          {{ $t('login.lblDescriptions3') }}<br>
          {{ $t('login.lblDescriptions4') }}
          <router-link :to="{path:'identification', query: $route.query}">{{$t('login.lblRegister')}}</router-link>
          {{ $t('login.lblDescriptions5') }}
          </p>
        </div>
        <div class="btn-container">
          <button
            type="submit"
            class="btn btn-primary"
            v-bind:class="{ 'btn-disabled': isDisabled}"
            v-bind:disabled="isDisabled">
            {{ $t('app.btnLogin') }}</button>
        </div>
      </form>
      <div class="link-container">
        <router-link :to="{path:'forgotpass', query: $route.query}" >{{$t('login.lblPasswordForgot')}}</router-link>
      </div>
      <div class="link-container">
        <router-link :to="{path:'identification', query: $route.query}">{{$t('login.lblRegister')}}</router-link>
      </div>
    </div>
    <div class="newpassword"  v-if="!signedIn && requiredNewPass">
      <div class="sectionHeader">
        {{ $t('login.lblTemporaryPassword') }}
      </div>
      <div class="sectionheader">
        <p>{{ $t('login.lblNewPasswordInputMessage') }}</p>
      </div>
      <form id="chgform" @submit.prevent="chgpass">
        <div class="form-label">
          <label for="inputNewpassword">{{ $t('login.lblNewPassword') }}</label>
          <input
            id="inputNewpassword"
            type="password"
            :placeholder="$t('login.placeholderPassword')"
            v-model="newpassword" required>
        </div>
        <div class="validMsg" v-html="$t(this.errorMessage)" />
        <div class="descriptions">
          <p>
          {{ $t('login.lblNewPasswordDescription1') }}<br>
          {{ $t('login.lblNewPasswordDescription2') }}<br>
          {{ $t('login.lblNewPasswordDescription3') }}<br>
          {{ $t('login.lblNewPasswordDescription4') }}<br>
          {{ $t('login.lblNewPasswordDescription5') }}<br>
          </p>
        </div>
        <div class="btn-container">
          <button type="submit" 
            class="btn btn-primary"
            v-bind:class="{ 'btn-disabled': isDisabled}"
            v-bind:disabled="isDisabled"
          >{{ $t('app.btnChange') }}</button>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import Amplify from 'aws-amplify';
import { AmplifyEventBus } from 'aws-amplify-vue'
import { deviceInfo, getRecaptchaV3Token, recapcthaV3Authenticate} from '@/lib/api/commb-api'
import { activate } from '@/lib/api/commb-api'
dayjs.locale('ja');

export default {
  name: 'Login',
  data () {
    return {
      authSiteUrl: process.env.VUE_APP_COMMUNITY_SITE_URL,
      helpSiteUrl: process.env.VUE_APP_HELP_SITE_URL,
      v3_site_key: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      nextPage: '',
      username: '',
      password: '',
      newpassword: '',
      errorMessage: '',
      message: '',
      result: '',
      token: '',
      isDisabled:false,
      signedIn: false,
      requiredNewPass: false,
      expDate: dayjs().add(90,'day').format('YYYY/MM/DD'),
    }
  },
  async beforeCreate() {
    this.$router.push({ path: 'onetime-input', query: this.$route.query}).catch(() => {})

    window.localStorage.clear();
    this.requiredNewPass = false
    try {
      await Amplify.Auth.currentAuthenticatedUser()
      this.signedIn = true
    } catch (err) {
      this.signedIn = false
    }
    AmplifyEventBus.$on('authState', info => {
      if (info === 'signedIn') {
        this.signedIn = true
      } else {
        this.signedIn = false
      }
    });
  },
  mounted() {
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${this.v3_site_key}`)
    document.head.appendChild(recaptchaScript);
    },
  methods: {
    async login () {
      this.requiredNewPass = false
      this.signedIn = false
      this.isDisabled = true
      try {
        this.errorMessage = '';
        const reCaptchaToken = await getRecaptchaV3Token();
        const res = await recapcthaV3Authenticate(reCaptchaToken);

        // reCAPTCHAスコアをチェック
        if(res.result === 'NG') throw('LowRecaptchaScore');

        const user = await Amplify.Auth.signIn(this.username.replace('0','+81'), this.password);

        this.result = user

        //パスワードの有効期限をチェック
        if(user.signInUserSession){
          const remain = user.signInUserSession.idToken.payload['custom:PwRemainingDays']
          if(remain < 0){
            throw('ExpiredPassword');
          }
        }

        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.requiredNewPass = true
          AmplifyEventBus.$emit('localUser', user)
          this.isDisabled = false
          return AmplifyEventBus.$emit('authState', 'requireNewPassword')
        }

        const DeviceAttributes = {
          AppVersion:'None',
          UIID:'None',
          OSName: window.navigator.platform,
          OSVersion:'None',
          ModelName:'None'
        }
        const config = {
          headers: {
            'Authorization': `Bearer ${user.signInUserSession.idToken.jwtToken}`
          }
        }
        await deviceInfo('02', DeviceAttributes, config)
        this.signedIn = true
        this.$root.$data.idToken = user.signInUserSession.idToken.jwtToken
        window.localStorage.clear();

        // https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
        this.$router.push({ path: 'logined', query: this.$route.query}).catch(() => {})

      } catch (err) {
        this.isDisabled = false
        if(Amplify.Logger.LOG_LEVEL === 'DEBUG'){ window.console.log(err);}

        if(err === 'ExpiredPassword'){
          this.errorMessage = 'login.errorMessageExpire';
        }else if(err && err.code === 'UserLambdaValidationException'){
          this.errorMessage = (err.message === 'PreAuthentication failed with error password attempts exceeded.')
            ? 'login.errorMessageLoginChallengeCount'
            : 'login.errorMessage';
        } else if(err === 'LowRecaptchaScore') {
          this.errorMessage = 'login.errorMessageLowRecaptchaScore';
        } else {
          this.errorMessage = 'login.errorMessage';
        }
      }
    },
    async chgpass () {
      this.isDisabled = true
      this.errorMessage = '';
      this.token = '';
      try {
        const u = await Amplify.Auth.completeNewPassword(
          this.result, this.newpassword, {
            'custom:Expiredate': this.expDate,
            'custom:PwRemainingDays': '90',
          }
        )
        this.token = u.signInUserSession.idToken.jwtToken;
      } catch (err) {
        this.errorMessage =  'login.errorMessage2';
        this.isDisabled = false
        return
      }

      try {
        const DeviceAttributes = {
          AppVersion:'None',
          UIID:'None',
          OSName: window.navigator.platform,
          OSVersion:'None',
          ModelName:'None'
        }
        const config = {
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        }
        await activate('02', DeviceAttributes, config)

        this.requiredNewPass = false
        this.signedIn = true
        this.$root.$data.idToken = this.token

        // https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
        this.$router.push({ path: 'logined', query: this.$route.query}).catch(() => {})

      } catch (err) {
        this.errorMessage =  'login.errorMessage3';
        this.isDisabled = false
      }
      this.isDisabled = false
    }
  }
}
</script>